<template>
  <div class="detail-summary-card">
    <p class="detail-summary-card__title">Summary</p>
    <div class="detail-summary-card__description pt-0">
      <!-- <img src="./icons/emojis/cloud.png" /> -->
      <div class="detail-summary-card__description-text pb-0">{{ company.about }}</div>
    </div>
    <p class="detail-summary-card__title mt-8">Est. Employees</p>
    <div class="detail-summary-card__description pt-0">
      <div class="detail-summary-card__description-text pb-0"> {{ company.employees }}</div>
    </div>
    <p class="detail-summary-card__title mt-8">Est. Revenue</p>
    <div class="detail-summary-card__description pt-0">
      <!-- <img src="./icons/emojis/money.png" /> -->
      <div class="detail-summary-card__description-text pb-0"> {{ company.revenue }} / year</div>
    </div>
    <p class="detail-summary-card__title mt-8">Est. Traffic</p>
    <div class="detail-summary-card__description pt-0">
      <!-- <img src="./icons/emojis/stars.png" /> -->
      <div class="detail-summary-card__description-text pb-0">{{ company.traffic }} views / month</div>
    </div>
    <v-btn class="detail-summary-card__button mt-8" width="100%" @click="goto(company.website)">
      Go to {{ company.name }} &rarr;
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "DetailSummaryCard",
  components: {},
  methods: {
    goto(url) {
      window.open(url, "_blank");
    }
  },
  props: {
    company: {}
  },
  data: () => ({})
};
</script>

<style>
.detail-summary-card {
  background-color: #fff5d5;
  border-radius: 12px;
  padding: 32px 24px 24px 24px;
  color: #030134;
  background-image: url(../assets/footer-vector-blue-2.png);
  background-position: right bottom;
  background-repeat: no-repeat, no-repeat;
  max-width: 400px;
  min-width: 320px;
}

.detail-summary-card__title {
  font-weight: 800;
  font-size: 15px;
  line-height: 1.5;
  /* margin-bottom: 44px !important; */
}

.detail-summary-card__description {
  display: flex;
  align-items: flex-start;
}

.detail-summary-card__description-text {
  margin-left: 12px;
}
.detail-summary-card__description-text p {
  margin-bottom: 0px !important;
}

.detail-summary-card__button.v-btn.v-size--default {
  border-radius: 12px;
  padding: 12px 18px;
  box-shadow: none;
  background-color: #f8d153 !important;
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
}
</style>
